<template>
  <ion-app>
    <ion-content>
      <ion-grid>
        <div class="error-block">
          <p class="mt-0 mb-2 text-md dark bold">Página em desenvolvimento!</p>
          <p class="mt-0 mb-0 text-sm green cursor-pointer" @click="gotoBack">
            <ion-icon mode="ios" name="return-right"></ion-icon>
            Retorne ao app
          </p>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  name: "ErrorPage",
  methods: {
    gotoBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: transparent !important;
}
.error-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  z-index: 1000;
  background: white;
  z-index: 1000;
}
</style>
